import React, { useState, useEffect, useRef } from 'react';
import '../style/LayerControls.css';
import ColorPicker from './ColorPicker';
import Icon from '@mdi/react';
import * as Accordion from '@radix-ui/react-accordion';
import { handleNumberInput, clampNumberInput } from "../utils/inputValidators";
import Personalize from './layer/Personalize';
import TitleArea from './common/TitleArea';
import {getRandomColor} from '../utils/colorUtils'
import PrintStyleSelector from './styling/PrintStyleSelector';
import FrameSelector from './FrameSelector';
import PdfExportButton from './layer/PdfExportButton.js';

import {
  mdiCircleOutline,
  mdiCircle,
  mdiSquareOutline,
  mdiSquare,
  mdiTriangleOutline,
  mdiTriangle,
  mdiHexagonOutline,
  mdiHexagon,
  mdiChevronDown,
  mdiEye,
  mdiEyeOff
} from '@mdi/js';
import { use } from 'react';
const LayerControls = ({ layerSettings, onLayerChange, setLayerSettings, onSave, step, setStep, initialSettings, personalSettings, setPersonalSettings, formattedDate, setFormattedDate, onGenerateImage, otherSettings, setOtherSettings, frameSettings, setFrameSettings, frameOptions, loadedGraphicId }) => {
  /* const sizeOptions = [800, 2000, 5000, 10000]; */
  const [dialogIndex, setDialogIndex] = useState(null);
  //const [step, setStep] = useState(1);
const initDateInputFromLayers = () => {
  console.log('initDateInputFromLayers', layerSettings);
  if (!Array.isArray(layerSettings) || layerSettings.length < 3) {
    return { month: '', date: '', year: '' };
  }
  const toStr = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? String(n) : '';
  };
  return {
    month: toStr(layerSettings[0].numShapes),
    date:  toStr(layerSettings[1].numShapes),
    year:  toStr(layerSettings[2].numShapes),
  };
};

const [dateInput, setDateInput] = useState(initDateInputFromLayers);
const [openAccordion, setOpenAccordion] = useState('');
useEffect(() => {
  if (step === 2) {
    setOpenAccordion('layer-0');
  }
}, [step]);

useEffect(() => {
  // show that we're entering the same logic
  const frame = frameSettings?.material;
  const paperEls = document.querySelectorAll('.paper-text');
  const canvasEls = document.querySelectorAll('.canvas-text');

  // Guard so we can see when condition is hit
  if (step === 5) {
    console.log('step === 5 branch executing');
    if (frame === 'paper') {
      paperEls.forEach(el => { el.style.display = 'flex'; el.setAttribute('aria-hidden', 'false'); });
      canvasEls.forEach(el => { el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); });
    } else {
      canvasEls.forEach(el => { el.style.display = 'flex'; el.setAttribute('aria-hidden', 'false'); });
      paperEls.forEach(el => { el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); });
    }
  } else {
    paperEls.forEach(el => { el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); });
    canvasEls.forEach(el => { el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); });
  }

}, [frameSettings?.material, step]);

useEffect(() => {
  if (loadedGraphicId && layerSettings[0].numShapes) setDateInput(initDateInputFromLayers());
}, [layerSettings]);
/*   const [formattedDate, setFormattedDate] = useState(''); */
  const [isresetting, setIsresetting] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  
  const shapeTypes = ['circle', 'square', 'triangle', 'hexagon'];
  const shapeIcons = {
    circle: { outline: mdiCircleOutline, solid: mdiCircle },
    square: { outline: mdiSquareOutline, solid: mdiSquare },
    triangle: { outline: mdiTriangleOutline, solid: mdiTriangle },
    hexagon: { outline: mdiHexagonOutline, solid: mdiHexagon },
  };
  const prevInputRef = useRef(dateInput);
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 100;
  const maxYear = currentYear + 50;
  const step1Text = "Begin by entering your special date below. This can be an anniversary, birthday, or any day that you want to celebrate, for any reason!";
  const step2Text = "<p>Make the design your own by using our tools below. Change the colors, shapes and sizes to your preference.</p> <p>Or see what is possible by using our randomizer.</p>";
  const noteText = "Using the randomizer will change any custom settings you have made below.";
  const personalText = "Add something special to personalize your design. Select a font, add your text and size to your preference.";
  
  useEffect(() => {
    const prevInput = prevInputRef.current;

    // Find changed key
    const changedKey = (['month', 'date', 'year']).find(
      key => dateInput[key] !== prevInput[key]
    );
    setIsFormValid(
      dateInput.month && 
      dateInput.date && 
      dateInput.year
    );
    // Update only if there's a change
    if (changedKey) {
      const updatedSettings = layerSettings.map(layer => {
        if (layer.groupType === changedKey) {
          return {
            ...layer,
            numShapes: dateInput[changedKey], // Only update changed key
          };
        }
        return layer;
      });
      setLayerSettings(updatedSettings);
      prevInputRef.current = dateInput; // Update the ref to the new input
    }
  }, [dateInput]);

  const getGradientCSS = (colorData) => {
  if (colorData.type === 'gradient') {
    const directionMap = {
      linear: colorData.degree?colorData.degree:'to right',
      radial: 'circle',
      conic: 'from 0deg'
    };
    const direction = directionMap[colorData.gradientType] || colorData.degree;
    return `${colorData.gradientType}-gradient(${direction}, ${colorData.color1}, ${colorData.color2})`;
  } else {
    return colorData.color;
  }
};

const resetDesign = (isReset) => {
  const defaultPersonal = {
    showTitle: true,
    titleText: "Add Title",
    titleFontFamily: "Alex Brush",
    titleFontSize: 42,

    showSubtitle: false,
    subtitleText: "Add sub title",
    subtitleFontFamily: "Alex Brush",
    subtitleFontSize: 24,

    showLegend: false,
    legendText: "",
  };
  if(isReset) {
     setDateInput({ month: '', date: '', year: '' });
     setLayerSettings(initialSettings);
     clearAllSpiroData();
     setIsresetting(true)
     setPersonalSettings(defaultPersonal)
  }else{
    setIsresetting(false)
  }
  setStep(1);
}

const clearAllSpiroData = () => {
  localStorage.removeItem('capturedImage');
  localStorage.removeItem('spiroLayerSettings');
  localStorage.removeItem('spiroPersonalSettings');
  
};
const updateFromDateAndRandomize = () => {
  const { month, date, year } = dateInput;
  const parsedMonth = parseInt(month);
  const parsedDate = parseInt(date);
  const parsedYear = parseInt(year);
  // Step 1: Update numShapes based on date
  const updatedSettings = layerSettings.map((layer, index) => {
    if (index === 0) return { ...layer, numShapes: parsedMonth };
    if (index === 1) return { ...layer, numShapes: parsedDate };
    if (index === 2) return { ...layer, numShapes: parsedYear };
    return layer;
  });

  // Step 2: Randomize shapeType and colorData
  const randomized = updatedSettings.map((layer, i) => {
    //const shapeType = shapeTypes[Math.floor(Math.random() * shapeTypes.length)];
    const randOpp = i === 2 ? true : false;
    const colorData = {
      type: 'solid',
      color: getRandomColor(randOpp),
    };
    return {
      ...layer,
      /* shapeType, */
      colorData,
    };
  });

  // Step 3: Apply final settings
  setLayerSettings(randomized);
};

const randomizeLayers = () => {
  const randomBg = Math.random() < 0.5 ? 'dark' : 'bright';

  const randomized = layerSettings.map((layer, i) => {
    const shapeType = shapeTypes[Math.floor(Math.random() * shapeTypes.length)];
    const isGradient = Math.random() < 0.5;
    const gradientType = Math.random() < 0.5 ? 'linear' : 'radial';
    const shapeRadius = Math.floor(Math.random() * (100 - 25 + 1)) + 25;
    const randOpp = i === 2 ? true : false;
    const colorData = isGradient
      ? {
          type: 'gradient',
          gradientType,
          color1: getRandomColor(randOpp),
          color2: getRandomColor(randOpp),
          degree: '0deg',
        }
      : {
          type: 'solid',
          color: getRandomColor(randOpp),
        };

    const updatedLayer = {
      ...layer,
      shapeRadius,
      shapeType,
      colorData,
    };

    if (i === 0) {
      setOtherSettings((prev) => ({
        ...prev,
        style: randomBg,
      }));
      //updatedLayer.backgroundColor = randomBg;
    } 

    return updatedLayer;
  });

  setLayerSettings(randomized);
};


  const handleCreateDate = () => {
    const { month, date, year } = dateInput;
  
    if (!month || !date || !year) {
      alert('Please enter month, date, and year before continuing.');
      return;
    }
  
    const parsedMonth = parseInt(month);
    const parsedDate = parseInt(date);
    const parsedYear = parseInt(year);
  
    const dateObj = new Date(`${year}-${month}-${date}`);
    const formatted = dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).replace(/(\d{1,2})(,)/, '$1th,');
  
    setFormattedDate(formatted);
    //console.log('date',dateInput);
    // Update numShapes for the first 3 layers
    const updatedSettings = layerSettings.map((layer, index) => {

      if (index === 0) return { ...layer, numShapes: parsedMonth };
      if (index === 1) return { ...layer, numShapes: parsedDate };
      if (index === 2) return { ...layer, numShapes: parsedYear };

      
      return layer;
    });
    
    setLayerSettings(updatedSettings);
    
    if(isresetting){
      setTimeout(() => updateFromDateAndRandomize(), 0);
      setStep(2);
    }else{
      setStep(3);
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // remove if you want instant jump
    });
  };
  
/*   const showHideLayer = (index) => {
    const updatedSettings = layerSettings.map((layer, i) => {
      return {
        ...layer,
        showItem: index==i?!layer.showItem:layer.showItem,
      };
    })
    setLayerSettings(updatedSettings);
  } */
const showHideLayer = (index) => {
  setLayerSettings(prev =>
    prev.map((layer, i) => ({
      ...layer,
      showItem: i === index ? !layer.showItem : layer.showItem,
    }))
  );
}
const showCatalog = () => {
  
  onGenerateImage();
  
}
  const handleColorChange = (index, newColor) => {
    setLayerSettings(prev => {
  return prev.map((layer, i) => {
    if (i !== index) return layer;

    let updatedColorData = layer.colorData;

    if (
      typeof newColor === 'string' &&
      (newColor.startsWith('linear-gradient') || newColor.startsWith('radial-gradient'))
    ) {
      const match = [...newColor.matchAll(/(rgba?\([^)]*\))\s*(\d+%)/gi)].map(match => ({
        color: match[1],
        stop: match[2],
      }));

      if (match && match.length >= 2) {
        const color1 = match[0].color;
        const color2 = match[match.length - 1].color;
        const stop1 = match[0].stop;
        const stop2 = match[match.length - 1].stop;

        if (color1 === color2) {
          updatedColorData = {
            type: 'solid',
            color: color1,
          };
        } else {
          const gradientType = newColor.startsWith('radial-gradient') ? 'radial' : 'linear';
          let degree = "0deg";

          if (gradientType === 'linear') {
            const degMatch = newColor.match(/linear-gradient\((\d+deg)/);
            if (degMatch && degMatch[1]) {
              degree = degMatch[1];
            }
          }

          updatedColorData = {
            type: 'gradient',
            gradientType,
            color1,
            color2,
            stop1,
            stop2,
            ...(degree ? { degree } : {}),
          };
        }
      }
    } else if (typeof newColor === 'string') {
      updatedColorData = {
        type: 'solid',
        color: newColor,
      };
    }

    console.log("layer (latest inside updater):", layer);

    return {
      ...layer,
      colorData: updatedColorData,
    };
  });
});

  };
  function getPickerValue(layer) {
    const { type, gradientType, color1, color2, color, degree } = layer.colorData || {};
    const direction = gradientType === 'radial' ? 'circle' : degree;
    return type === 'gradient'
      ? `${gradientType}-gradient(${direction}, ${color1} 0%, ${color2} 100%)`
      : color || '#000000';
  };

  return (
    <div className="layer-controls" >
      {/* Step 1: Enter Date */}
      {step === 1 && (
        <>
          <h2>Create a Design with Your Date </h2>
          <div>{step1Text}</div>
          <div className="input-row step-1">
            <div className="date-input-group">
              <input
                type="number"
                placeholder="00"
                min={1}
                max={12}
                value={dateInput.month}
                className={dateInput.month ? "has-value" : ""}
                onChange={(e) =>
                  setDateInput({
                    ...dateInput,
                    month: handleNumberInput(e.target.value, 1, 12),
                  })
                }
                  onBlur={(e) =>
                    setDateInput({
                      ...dateInput,
                      month: clampNumberInput(e.target.value, 1, 12),
                    })
                  }
              />
              <label>Month</label>
            </div>
            <div className="date-input-group">
              <input
                type="number"
                placeholder="00"
                min={1}
                max={31}
                value={dateInput.date}
                className={dateInput.date ? "has-value" : ""}
                onChange={(e) =>
                  setDateInput({
                    ...dateInput,
                    date: handleNumberInput(e.target.value, 1, 31),
                  })
                }
                onBlur={(e) =>
                  setDateInput({
                    ...dateInput,
                    date: clampNumberInput(e.target.value, 1, 31),
                  })
                }
              />
              <label>Day</label>
            </div>
            <div className="date-input-group">
              <input
                type="number"
                placeholder="0000"
                min={minYear}
                max={maxYear}
                value={dateInput.year}
                className={dateInput.year ? "has-value" : ""}
                onChange={(e) =>
                  setDateInput({
                    ...dateInput,
                    year: handleNumberInput(e.target.value),
                  })
                }
                onBlur={(e) =>
                  setDateInput({
                    ...dateInput,
                    year: clampNumberInput(e.target.value, minYear, maxYear),
                  })
                }
              />
              <label>Year</label>
            </div>
          </div>

          <button className='create-btn' disabled={!isFormValid} onClick={handleCreateDate}>{`${isresetting?"Create Design":"Update Design"} `}</button>
           {/* <div className='divider only-mobile'></div> */}
        </>
      )}

      {/* Step 2: Show formatted date and toggle background */}
      {step === 2 && (
        <>
        <TitleArea title={'Customize'} subTitle={step2Text} forMobile={false}/>
        <button className='randomize-btn' onClick={randomizeLayers}>Randomize</button>
        <div className='note-text'><span>Note!</span> {noteText}</div>
          {/* <div className='divider only-desktop'></div> */}
          <Accordion.Root
            type="single"
            value={openAccordion}
            onValueChange={setOpenAccordion}
            className="w-full"
            collapsible
          >
          {layerSettings.map((layer, index) => (
            <Accordion.Item
              key={index}
              value={`layer-${index}`}
            >
            <div key={index} className="layer-settings">
              <Accordion.Header className="accordion-header">
                <Icon path={layer.showItem ? mdiEye : mdiEyeOff} size={0.8} className="eye-icon" onClick={() => showHideLayer(index)}/>
                <Accordion.Trigger className="accordion-trigger">
                  <h3> Your {layer.name}: {layer.numShapes}</h3>
                  <span className="accordion-icon">
                    <Icon path={mdiChevronDown} size={1} />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="px-4 pb-4">
              {/* Row 1: Number of Shapes and Radius */}
              
              <div className="input-row">
               <div className="input-group shape-selector">
                  <label>Shape Type:</label><br />
                  <div className="shape-options">
                    {Object.keys(shapeIcons).map((shape) => (
                      <button
                        key={shape}
                        className={`shape-button ${layer.shapeType === shape ? 'selected' : ''}`}
                        onClick={() => onLayerChange(index, 'shapeType', shape)}
                        title={shape.charAt(0).toUpperCase() + shape.slice(1)}
                      >
                        <Icon
                          path={layer.shapeType === shape ? shapeIcons[shape].outline : shapeIcons[shape].outline}
                          size={1.2}
                          color={layer.shapeType === shape ? '#000' : '#555'}
                        />
                      </button>
                    ))}
                  </div>
                </div>
                <div className="input-group">
                  <div className='color-picker'>
                    <button
                      onClick={() => setDialogIndex(index)}
                      className="color-preview"
                      style={{
                        background: layer.colorData.type === 'gradient' ? getGradientCSS(layer.colorData) : layer.colorData.color,
                      }}
                      title="Click to choose color"
                    />
                    <label>Color</label>
                  </div>
                  {/* Stroke Width — only for Month & Day */}
                    {index !== 2 && (
                      <div className="input-group">
                        <div className="stroke-select">
                          <select
                            value={layer.strokeWidth || 1}
                            onChange={(e) =>
                              onLayerChange(index, 'strokeWidth', Number(e.target.value))
                            }
                          >
                            <option value={1}>1x</option>
                            <option value={2}>2x</option>
                           {/*  <option value={3}>3x</option> */}
                          </select>
                          <label>Stroke</label>
                        </div>
                      </div>
                    )}


                  </div>
                  {/*<div className="input-group">
                   <div className='blend-mode'>
                    <div>&nbsp;</div>
                    <select
                      value={layer.blendMode || "normal"}
                      onChange={(e) => onLayerChange(index, 'blendMode', e.target.value)}
                    >
                      <option value="normal">Blend</option>
                      <option value="multiply">Multiply</option>
                      <option value="screen">Screen</option>
                      <option value="overlay">Overlay</option>
                      <option value="darken">Darken</option>
                      <option value="lighten">Lighten</option>
                      <option value="color-dodge">Color Dodge</option>
                      <option value="color-burn">Color Burn</option>
                      <option value="hard-light">Hard Light</option>
                      <option value="soft-light">Soft Light</option>
                      <option value="difference">Difference</option>
                      <option value="exclusion">Exclusion</option>
                    </select>
                    </div> 
                </div>*/}
              </div>

              {/* Row 2: Opacity and Blend Mode */}
              <div className="input-row">
               
                <div className="input-group">
                  <label>Size:</label>
                  <input
                    type="range"
                    min="25"
                    max="100"
                    value={layer.shapeRadius}
                    onChange={(e) => onLayerChange(index, 'shapeRadius', e.target.value)}
                  />
                </div>
                
              </div>
              {/* Color Picker Dialog */}
              {dialogIndex === index && (
                <div style={{ '--picker-bg': layer.colorData.type === 'gradient' ? getGradientCSS(layer.colorData) : layer.colorData.color }}>
                  <ColorPicker
                    value={getPickerValue(layer)}
                    onChange={(newColor) => handleColorChange(index, newColor)}
                    onClose={() => setDialogIndex(null)}
                  />
                </div>
              )}
              </Accordion.Content>
            </div>
            <div className='divider'></div>
            </Accordion.Item>
          ))}
          </Accordion.Root>
          {/* <h2>{formattedDate}</h2>
          <p>Nice! We’ve created a beautiful, random design with your special date!</p> */}
            {/* <div className='divider'></div>
            <h3>Now you can choose to: </h3>
            <ol>
              <li>Customize the design colors and shapes.</li>
              <li>Randomize the design colors and shapes.</li>
              <li>Use this design for your Spirogift.</li>
            </ol>
            <div className='divider'></div>
            <div className='cust-rand'>
              <button onClick={() => setStep(3)}>Customize</button>
              <button onClick={randomizeLayers}>Randomize</button>
            </div> */}
        </>
      )}

      {step === 3 && (
        <>
          <div className='personalize-wrapper'>
            <TitleArea title={'Personalize'} subTitle={personalText} forMobile={false}/>

            <Personalize 
              personalSettings={personalSettings} 
              setPersonalSettings={setPersonalSettings}/>
          </div>
        </>
      )}
      {step === 4 && (
        <>
           <PrintStyleSelector otherSettings={otherSettings} setOtherSettings={setOtherSettings}/>
        </>
      )}
      {step === 5 && (
        <>
           <FrameSelector frameSettings={frameSettings}  setFrameSettings={setFrameSettings} frameOptions={frameOptions} personalSettings={personalSettings}/>
           {/* <div style={{ marginTop: 12 }}>
            <PdfExportButton
              frameSize={frameSettings?.size || '12x16'}
              dpi={otherSettings?.exportDpi || 300}
              canvasSelector=".canvas"
              excludeSelectors={['.vertical-dimension', '.horizontal-dimension']}
              label="Download PDF"
              waitingText="Please wait, this might take time…"
            />
          </div> */}
        </>
      )}
      {/* {step == 0 && (
        <>
          <button className="proceed-button" onClick={() => step===4?showCatalog():setStep(4)}>
            <span className='text-gradient'> {step!=4?"Use This Design" : "I'm Done Personalizing"}</span>
          </button> 
          <div className='reset-section'>
            <div onClick={() => resetDesign(false)}>Change Date</div><div onClick={() => resetDesign(true)}>Restart Design</div>
          </div>
        </>
      )} */}
      </div>
  );
};

export default LayerControls;
